'use client';

import { usePathname } from 'next/navigation';

import { MarketingDesktopOnlyMessage } from '@/components/layout/marketing-desktop-only-message';
import {
  isMarketingDesktopOnlyPath,
  MARKETING_MOBILE_ENTRY_PATH,
} from '@/lib/navigation/marketing-desktop-only-paths';

type MarketingDesktopOnlyGateProps = {
  children: React.ReactNode;
};

/**
 * Marketing sub-routes (שיווק) are desktop-first. On mobile, show a clear message
 * instead of page UI. The dedicated entry route renders the same message in-page
 * (marketing routes skip this gate — see app-shell excluded paths).
 */
export function MarketingDesktopOnlyGate({ children }: MarketingDesktopOnlyGateProps) {
  const pathname = usePathname();

  if (!isMarketingDesktopOnlyPath(pathname) || pathname === MARKETING_MOBILE_ENTRY_PATH) {
    return <>{children}</>;
  }

  return (
    <>
      <div className="md:hidden">
        <MarketingDesktopOnlyMessage />
      </div>
      <div className="hidden md:block">{children}</div>
    </>
  );
}
